import { useCallback } from 'react';
import uuid from 'uuid';
import { toFlagId, useFlagsService } from '@atlassian/jira-flags';
import messages from './messages';

export const useSLAConfigActionsFlags = () => {
	const { showFlag, dismissFlag } = useFlagsService();

	const calendarSaveSuccessFlag = useCallback(
		(calendarName: string, isNewCalendar: boolean) => {
			const flagId = toFlagId(uuid.v4());
			const flagTitle = isNewCalendar
				? messages.createCalendarSuccessTitle
				: messages.editCalendarSuccessTitle;

			const description = isNewCalendar
				? [messages.createCalendarSuccessDescription, { calendarName }]
				: [messages.editCalendarSuccessDescription, { calendarName }];

			showFlag({
				id: flagId,
				type: 'success',
				title: flagTitle,
				// @ts-expect-error - TS2322 - Type '(MessageDescriptorV2 | { calendarName: string; })[]' is not assignable to type 'FlagMessage | undefined'.
				description,
				testId: `calendar-save-success-flag-${calendarName}`,
				actions: [
					{
						content: messages.calendarDismissWithGotIt,
						onClick: () => dismissFlag(flagId),
					},
				],
			});
		},
		[dismissFlag, showFlag],
	);

	const calendarSaveFailedFlag = useCallback(() => {
		const flagId = toFlagId(uuid.v4());

		showFlag({
			id: flagId,
			type: 'warning',
			title: messages.calendarSaveFailedTitle,
			description: messages.calendarSaveFailedDescription,
			testId: 'calendar-save-failure-flag',
			actions: [
				{
					content: messages.calendarDismissWithGotIt,
					onClick: () => dismissFlag(flagId),
				},
			],
		});
	}, [dismissFlag, showFlag]);

	const calendarImportPartialFailureFlag = useCallback(() => {
		const flagId = toFlagId(uuid.v4());

		showFlag({
			id: flagId,
			type: 'warning',
			title: messages.calendarImportPartialFailureTitle,
			description: messages.calendarImportPartialFailureDescription,
			testId: 'calendar-import-partial-failure-flag',
			actions: [
				{
					content: messages.calendarDismissWithGotIt,
					onClick: () => dismissFlag(flagId),
				},
			],
		});
	}, [dismissFlag, showFlag]);

	const calendarImportParserFailureFlag = useCallback(() => {
		const flagId = toFlagId(uuid.v4());

		showFlag({
			id: flagId,
			type: 'error',
			title: messages.calendarImportParserFailureTitle,
			description: messages.calendarImportParserFailureDescription,
			testId: 'calendar-import-parser-failure-flag',
			actions: [
				{
					content: messages.calendarDismissWithGotIt,
					onClick: () => dismissFlag(flagId),
				},
			],
		});
	}, [dismissFlag, showFlag]);

	const calendarImportParserServerFailureFlag = useCallback(() => {
		const flagId = toFlagId(uuid.v4());

		showFlag({
			id: flagId,
			type: 'error',
			title: messages.calendarImportParserServerFailureTitle,
			description: messages.calendarImportParserServerFailureDescription,
			testId: 'calendar-import-parser-server-failure-flag',
			actions: [
				{
					content: messages.calendarDismissWithGotIt,
					onClick: () => dismissFlag(flagId),
				},
			],
		});
	}, [dismissFlag, showFlag]);

	const calendarImportSuccessFlag = useCallback(() => {
		const flagId = toFlagId(uuid.v4());

		showFlag({
			id: flagId,
			type: 'success',
			title: messages.calendarImportSuccessTitle,
			description: messages.calendarImportSuccessDescription,
			testId: 'calendar-import-success-flag',
			actions: [
				{
					content: messages.calendarDismissWithGotIt,
					onClick: () => dismissFlag(flagId),
				},
			],
		});
	}, [dismissFlag, showFlag]);

	const calendarDeleteSuccessFlag = useCallback(
		(calendarName: string) => {
			const flagId = toFlagId(uuid.v4());
			showFlag({
				id: flagId,
				type: 'success',
				title: messages.deleteCalendarSuccessTitle,
				description: [messages.deleteCalendarSuccessDescription, { calendarName }],
				testId: 'calendar-delete-success-flag',
			});
		},
		[showFlag],
	);

	const timeMetricSaveSuccessFlag = useCallback(
		(timeMetricName: string) => {
			const flagId = toFlagId(uuid.v4());
			const flagTitle = [messages.timeMetricSaveSuccessTitle, { timeMetricName }];

			showFlag({
				id: flagId,
				type: 'success',
				// @ts-expect-error - TS2322 - Type '(MessageDescriptorV2 | { timeMetricName: string; })[]' is not assignable to type 'FlagMessage'.
				title: flagTitle,
				testId: `time-metric-save-success-flag-${timeMetricName}`,
			});
		},
		[showFlag],
	);

	return {
		calendarImportPartialFailureFlag,
		calendarImportParserFailureFlag,
		calendarImportParserServerFailureFlag,
		calendarImportSuccessFlag,
		calendarSaveSuccessFlag,
		calendarSaveFailedFlag,
		calendarDeleteSuccessFlag,
		timeMetricSaveSuccessFlag,
	};
};
